import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[ManagedEvents SetFilter] Action',
  ResetFilter: '[ManagedEvents ResetFilter] Action',
}

const initialManagedEventsState: IManagedEventsState = {
  filter: {
    siteTypeId: '',
    siteIds: [],
    dateFrom: new Date().toISOString().split('T')[0],
    dateTo: '',
    statuses: [],
  },
}

export interface IManagedEventsState {
  filter?: {
    siteTypeId: string
    siteIds: string[]
    dateFrom: string
    dateTo: string
    statuses: string[]
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-ManagedEvents', whitelist: ['filter']},
  (
    state: IManagedEventsState = initialManagedEventsState,
    action: ActionWithPayload<IManagedEventsState>
  ) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialManagedEventsState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
